import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

/**
 * Translated message.
 */
const LocalizedText = ({ children, values, ...props }) => {
  const intl = useIntl()
  const text = intl.formatMessage(props, values)
  return children ? children(text) : <span title={text}>{text}</span>
}

LocalizedText.propTypes = {
  id: PropTypes.string,
  values: PropTypes.object,
  children: PropTypes.func,
}

export default LocalizedText
